export const ApproveAction = {
  AGREE: "agree",
  REJECT: "reject",
  TRANSFER: "transfer"
};
